import {useEffect, useState } from 'react';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import axios from '../../axios';
import M from 'materialize-css';
import ServiciosCategoriasModal from './ServiciosCategoriasModal';
import NoPermissions from '../NoPermissions/NoPermissions';
import Loader from '../../Layout/Loaders/Loader';
import usePermisos from '../../hooks/usePermisos';
import { Table, TableSwitch, useTableSort, useTablePagination } from '../UI';

// Lista de permisos requeridos para este componente
const PERMISOS_REQUERIDOS = [
    'products_create',
    'products_read',
    'products_update',
    'products_delete',
    'products_btn_read_category'
];


const Servicios = () => {
    const [productos, setProductos] = useState([]);
    const [productosRaw, setProductosRaw] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [productoSelected,setProductoSelected] = useState({});
    const [updated,setUpdated] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    // Hook personalizado para permisos
    const { permisos,loading: loadingPermisos, tienePermiso } = usePermisos(PERMISOS_REQUERIDOS);

    // Hook de sorting - ordena los datos originales
    const { sortedData, sortConfig, handleSort } = useTableSort(productos);

    // Hook de paginación - pagina los datos ordenados
    const { 
        paginatedData, 
        page, 
        setPage, 
        itemsPerPage, 
        setItemsPerPage, 
        totalItems 
    } = useTablePagination(sortedData, { page: 1, itemsPerPage: 10 });

    useEffect(() => {   
        axios.get('api/products')
        .then( res=>{
            console.log('todos los producto',res.data)
            setProductos(res.data);
            setProductosRaw(res.data);
            setSearchTerm('');
            setUpdated(false);
        }).catch(e =>{console.log(e, 'Error todos los producto')})
    },[updated])

    const _delete = (productoId) =>{
        if(window.confirm("Realmente deseas borrar a esta producto, si lo borras no se podra recuperar despues")) {
            axios.delete(`api/products/${productoId}`)
            .then(res=>{
                M.toast({html:'<i className="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span>'+res.data.message+'</span>',classes:"success-notify"})
                setProductos(productos.filter(u=>u.id!==res.data.producto.id))
                setProductosRaw(productosRaw.filter(u=>u.id!==res.data.producto.id))
            }).catch(e=>console.log("error",e))
        }
    }

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
        if (value.length > 0) {
            const filtered = productosRaw.filter((p) =>
                p.nombre_producto?.toLowerCase().includes(value)
            );
            setProductos(filtered);
        } else {
            setProductos(productosRaw);
        }
    };

    const handleResetFilters = () => {
        setSearchTerm('');
        setProductos(productosRaw);
    };

    const _handleModal = (product) => {
        setProductoSelected(product);
        setIsModalOpen(true);
    };

    const _closeModal = () => {
        setIsModalOpen(false);
    };

    const handleToggle = (newValue, servicio) => {
        // Crear copia para no mutar el original
        const servicioActualizado = {
            ...servicio,
            activo: newValue ? 1 : 0
        };
        _updateActive(servicioActualizado);
    };

    const handleToggleVisibleWeb = (newValue, servicio) => {
        // Crear copia para no mutar el original
        const servicioActualizado = {
            ...servicio,
            visible_web: newValue ? 1 : 0
        };
        _updateActive(servicioActualizado);
    };

    const handleToggleSoloPresencial = (newValue, servicio) => {
        // Crear copia para no mutar el original
        const servicioActualizado = {
            ...servicio,
            solo_presencial: newValue ? 1 : 0
        };
        _updateActive(servicioActualizado);
    };

    const _updateActive = (producto) =>{
        axios.put(`api/products/${producto.id}`,producto)
        .then(resp=>{
            const normalizado = {
                ...resp.data,
                activo: parseInt(resp.data.activo) || 0,
                visible_web: parseInt(resp.data.visible_web) || 0,
                solo_presencial: parseInt(resp.data.solo_presencial) || 0,
            };
            setProductos(prev =>
                prev.map(item => (item.id === normalizado.id ? normalizado : item))
            );
            setProductosRaw(prev =>
                prev.map(item => (item.id === normalizado.id ? normalizado : item))
            );
            M.toast({html:'<i class="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span>Servicio actualizado exitosamente</span>',classes:"success-notify"})
        }).catch(e=>{
            console.log("error",e)
            if(e.message) M.toast({html:'<i className="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span>'+e.message+'</span>',classes:"error-notify"})
        })
    }

    // Configuración de columnas para la tabla
    const columns = [
        {
            key: 'id',
            label: 'ID',
            sortable: true,
            width: '60px'
        },
        {
            key: 'nombre_producto',
            label: 'Servicio/Producto',
            sortable: true,
        },
        {
            key: 'categories',
            label: 'Categorias',
            render: (categorias, row) => (
                tienePermiso('products_btn_read_category') ? (
                    <div className='cont-textos' style={{border:'solid transparent'}}>
                        <button 
                            className={categorias?.length > 0 ? "btn-info" : "btn-delete"} 
                            onClick={() => _handleModal(row)}
                        >
                            {categorias?.length > 0 ? "Ver" : "Agregar"} Categorías
                        </button>
                    </div>
                ) : null
            )
        },
        {   key: 'sucursals',
            label: 'Sucursales',
            render: (sucursals) => (
                (sucursals.length === 0) ? (<span className='text-red-500'>No asignado</span>) : 
                (  
                    <ul class="list-disc"> 
                        {sucursals?.map(sucursal => (
                            <li key={sucursal.id}>{sucursal.nombre_sucursal}</li>
                        ))}
                    </ul>
                )
            )
        },
        {
            key: 'precio_unidad',
            label: 'Precio lista',
            sortable: true,
            render: (value) => <span className='text-green-600'>{`$${value}`}</span>
        },
        {
            key: 'duracion_aproximada',
            label: 'Duración (Mins)',
            sortable: true,
            render: (value) => `${value} min`
        },
        {
            key:'dias_entrega',
            label:'Días de entrega',
            sortable: true,
            render: (value) => `${value} días`
        },
        {
            key:'dias_preparacion',
            label:'Días de preparación',
            render: (value) => `${value} días`,
            sortable: true,
        },
        {
            key: 'activo',
            label: 'Activo',
            align: 'center',
            sortable: true,
            render: (value, row) => (
            tienePermiso('products_update') ? (
                    <TableSwitch 
                        value={value}
                        activeColor='#11cdef'
                        onChange={handleToggle}
                        row={row}
                    />
                ) : null
            )
        },
        {
            key: 'visible_web',
            label: 'Visible en Web',
            align: 'center',
            sortable: true,
            render: (value, row) => (
            tienePermiso('products_update') ? (
                    <TableSwitch
                        value={value}
                        activeColor='#11cdef'
                        onChange={(newValue) => handleToggleVisibleWeb(newValue, row)}
                    />
                ) : null
            )
        },  
         {
            key: 'solo_presencial',
            label: 'No Requiere Cita',
            align: 'center',
            sortable: true,
            render: (value, row) => (
            tienePermiso('products_update') ? (
                    <TableSwitch
                        value={value}
                        activeColor='#11cdef'
                        onChange={(newValue) => handleToggleSoloPresencial(newValue, row)}
                    />
                ) : null
            )
        },  
    ];

    // Configuración de acciones
    const actions = [
        {
            type: 'edit',
            to: (row) => `${row.id}`,
            tooltip: 'Editar',
            permission: 'products_update',
        },
        {
            type: 'delete',
            onClick: _delete,
            tooltip: 'Eliminar',
            permission: 'products_delete',
        },
    ];

    return (
        <>
            <div className='container-admin-menu '> <Breadcrumb hasButton={tienePermiso('products_create')} hasFilters={false} /> </div>
            <div className='container-admin-container'>
                <div className='container-admin z-depth-1'>
                {loadingPermisos ? (
                    <div className='height-200 centrar'>
                        <Loader/>
                    </div>
                ) : !tienePermiso('products_read') ? (
                    <NoPermissions />
                ) : (
                    <>
                        {/* Barra de búsqueda */}
                        <div className="info-badge rounded-xl p-3 mb-4 flex flex-col md:flex-row items-center gap-3">
                            <div className="flex items-center gap-2">
                                <span className="text-white font-medium text-sm">Buscar:</span>
                            </div>
                            <div className="flex-1 flex items-center gap-2">
                                <div className="relative flex-1">
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 pr-10 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                        placeholder="Buscar por nombre de producto..."
                                        value={searchTerm}
                                        onChange={handleSearch}
                                    />
                                    <svg
                                        className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                    </svg>
                                </div>
                                {searchTerm && (
                                    <button
                                        onClick={handleResetFilters}
                                        className="px-4 py-2 bg-white text-gray-700 rounded-lg hover:bg-gray-100 transition-colors text-sm font-medium flex items-center gap-1"
                                        title="Limpiar búsqueda"
                                    >
                                        <img src="/images/clear-filters.png" alt="Limpiar" className="w-4 h-4" />
                                        Limpiar
                                    </button>
                                )}
                            </div>
                        </div>
                        <ServiciosCategoriasModal 
                            isOpen={isModalOpen}
                            onClose={_closeModal}
                            productoSelected={productoSelected}
                            setProductoSelected={setProductoSelected}
                            setUpdated={setUpdated}
                        />
                        <Table 
                            columns={columns}
                            data={paginatedData}
                            actions={actions}
                            permissions={permisos}
                            striped={true}
                            hoverable={true}
                            emptyMessage="No hay Servicios o Productos registrados"
                            sorting={{
                                field: sortConfig.field,
                                direction: sortConfig.direction,
                                onSort: handleSort
                            }}
                             pagination={{
                                page,
                                itemsPerPage,
                                totalItems,
                                onPageChange: setPage,
                                onItemsPerPageChange: setItemsPerPage
                            }}
                        />
                    </>
                )}
                </div>
            </div>
        </>
    );
};

export default Servicios;